import styled from 'styled-components';

export const TableContainer = styled.div`
  height: 100%;
  height: 350px;
  margin-top: 1rem;
`;
export const ButtonNavigation = styled.button`
  padding: 5px 10px;
  height: 40px !important;
`;

export const ButtonSeparator = styled.span`
  margin: 0px 1rem;
  width: 2px;
  border: 1px solid #bdbdbd;
  height: 50%;
`;

export const ContainerGrid = styled.div`
  .grid .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;

export const ContainerAcoes = styled.div`
  width: 100px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s;
  button {
    background: none;
    border: none;
    svg {
      font-size: 20pt;
    }
  }
`;
